import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { SERVICE_ENDPOINT } from '../../constants';
import { BaseResponse } from '../../models/api';
import {
  CreateBillingCodeResponse,
  CreateBillingCodeViewModel,
  UpdatePaymentMethodViewModel,
} from '../../models/api/payment';

@Injectable({
  providedIn: 'root',
})
export class PaymentHttpService {
  private _http = inject(HttpClient);

  updatePaymentMethod(request: UpdatePaymentMethodViewModel) {
    return this._http.post<BaseResponse>(
      SERVICE_ENDPOINT.updatePaymentMethod,
      request,
    );
  }

  payStore(request: CreateBillingCodeViewModel) {
    return this._http.post<CreateBillingCodeResponse>(
      SERVICE_ENDPOINT.payStore,
      request,
    );
  }
}
